
import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

type FormFieldProps = {
  id: string;
  label: string;
  type?: string;
  placeholder?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean;
  minLength?: number;
  icon?: React.ReactNode;
  rightElement?: React.ReactNode;
  error?: string;
};

const FormField = ({
  id,
  label,
  type = "text",
  placeholder,
  value,
  onChange,
  required = false,
  minLength,
  icon,
  rightElement,
  error,
}: FormFieldProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <Label htmlFor={id}>{label}</Label>
        {rightElement}
      </div>
      <div className="relative">
        {icon && (
          <div className="absolute left-3 top-2.5 h-4 w-4 text-muted-foreground">
            {icon}
          </div>
        )}
        <Input
          id={id}
          name={id}
          type={type}
          placeholder={placeholder}
          className={`${icon ? "pl-10" : ""} ${error ? "border-destructive" : ""}`}
          value={value}
          onChange={onChange}
          required={required}
          minLength={minLength}
          aria-invalid={!!error}
        />
      </div>
      {error && (
        <p className="text-sm text-destructive">{error}</p>
      )}
    </div>
  );
};

export default FormField;
